import React from 'react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { InsightsSection } from '../components/InsightsSection';
import { ScaleIcon } from 'lucide-react';
export function CriminalInvestigations() {
  return <div className="flex flex-col min-h-screen w-full bg-white" data-id="element-398">
      <Header data-id="element-399" />

      {/* Banner Section */}
      <section className="relative w-full h-[400px] bg-gradient-to-br from-kgi-blue-900 to-kgi-blue-800 overflow-hidden mt-20" data-id="element-400">
        <div className="absolute inset-0 bg-black opacity-20" data-id="element-401"></div>
        <div className="relative container mx-auto px-4 h-full flex items-center justify-center" data-id="element-402">
          <div className="text-center" data-id="element-403">
            <ScaleIcon className="h-20 w-20 text-white mx-auto mb-6 drop-shadow-lg" data-id="element-404" />
            <h1 className="font-serif text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-4 drop-shadow-lg" data-id="element-405">
              Criminal Investigations
            </h1>
            <p className="text-xl text-blue-100 max-w-2xl mx-auto drop-shadow" data-id="element-406">
              Expert defense investigation services for criminal cases
            </p>
          </div>
        </div>
      </section>

      {/* Content Section */}
      <section className="py-16 bg-white" data-id="element-407">
        <div className="container mx-auto px-4" data-id="element-408">
          <div className="max-w-4xl mx-auto" data-id="element-409">
            <div className="prose prose-lg max-w-none mb-12" data-id="element-410">
              <p className="text-xl text-gray-700 leading-relaxed mb-6" data-id="element-411">
                As one of only two licensed Certified Criminal Defense
                Investigators (CCDI) in Michigan and the only licensed CCDI in
                Ohio, Koda Group Inc. brings unparalleled expertise to criminal
                defense cases. Our investigators combine real-world law
                enforcement experience with advanced investigative techniques to
                build strong defense strategies that stand up in court.
              </p>

              <p className="text-lg text-gray-600 leading-relaxed mb-6" data-id="element-412">
                We understand that criminal cases require meticulous attention
                to detail, thorough evidence gathering, and expert witness
                location. Our team works closely with defense attorneys to
                uncover exculpatory evidence, interview witnesses, reconstruct
                crime scenes, and identify procedural errors that could impact
                your case. From misdemeanors to serious felonies, we provide the
                investigative support needed to ensure a fair trial and the best
                possible outcome.
              </p>

              <p className="text-lg text-gray-600 leading-relaxed mb-8" data-id="element-413">
                Our criminal investigation services include witness interviews
                and statements, crime scene analysis and reconstruction,
                evidence collection and preservation, alibi verification, expert
                witness location, background checks on witnesses and victims,
                surveillance operations, and comprehensive case documentation.
                We maintain the highest standards of confidentiality and work
                within legal and ethical boundaries to support your defense.
              </p>
            </div>

            <div className="text-center bg-gray-50 rounded-lg p-8" data-id="element-414">
              <h3 className="font-serif text-2xl font-bold text-kgi-blue-900 mb-4" data-id="element-415">
                Need Criminal Defense Investigation Support?
              </h3>
              <p className="text-gray-700 mb-6 max-w-2xl mx-auto" data-id="element-416">
                Contact our certified criminal defense investigators for a
                confidential consultation about your case.
              </p>
              <a href="/contact-koda-private-investigators.html" className="inline-flex items-center bg-kgi-red hover:bg-kgi-red-600 text-white font-bold py-4 px-10 rounded-full transition duration-300 shadow-xl text-lg" data-id="element-417">
                Schedule a Consultation
              </a>
            </div>
          </div>
        </div>
      </section>

      <InsightsSection data-id="element-418" />
      <Footer data-id="element-419" />
    </div>;
}